import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

let hasRegisteredCharts = false;

export const ensureChartJsRegistered = () => {
  if (hasRegisteredCharts) {
    return;
  }

  ChartJS.register(...registerables, ChartDataLabels);
  hasRegisteredCharts = true;
};

ensureChartJsRegistered();
